<template>
  <div class="component-wrap" v-if="hasSupport">
    <div class="component-title dark-theme">
      <h3 class="title-area">
        <span class="label">{{sectionInfo.title}}</span>
        <span class="count">{{totalCount | setNumberCommas}}</span>
      </h3>
      <a href="#" @click.prevent="viewAll(sectionInfo)" class="btn-more customer">더보기</a>
    </div>
    <search-support-list :list="faqList" :search-word="keyword" type="faq">
      <template slot="titleComponent">
        <SearchSupportListTitle title="FAQ" :total-count="faqTotalCount" :view-all-list-fn="()=>goAllView('faq')" />
      </template>
    </search-support-list>
    <search-support-list :list="noticeList" :search-word="keyword" type="notice">
      <template slot="titleComponent">
        <SearchSupportListTitle title="공지사항" :total-count="noticeTotalCount" :view-all-list-fn="()=>goAllView('notice_list')"/>
      </template>
    </search-support-list>
  </div>
</template>

<script>
import { setNumberCommas } from '@/common/utils/common'
import _ from 'lodash'
import { getSearch } from '@/common/utils/request'
import SearchSupportList from '@/components/search/SearchSupportList'
import SearchSupportListTitle from '@/components/search/SearchSupportListTitle'
import MultiSectionMixin from '@/mixins/multisection.mixin'
export default {
  components: {
    SearchSupportListTitle,
    SearchSupportList
  },
  mixins: [
    MultiSectionMixin
  ],
  filters: {
    setNumberCommas
  },
  props: {
    sectionInfo: {
      type: Object
    },
    searchWord: {
      type: String
    }
  },
  data () {
    return {
      totalCount: 0,
      faqList: [],
      faqTotalCount: 0,
      noticeList: [],
      noticeTotalCount: 0,
      keyword: ''
    }
  },
  methods: {
    getSupportListByType (type) {
      return getSearch({
        type,
        keyword: this.keyword,
        offset: 0,
        limit: 5,
        orderby: 'score',
        isplayymovie: 'y' // TODO: 공통 모듈 만들면 변경 pooqzone 관련
      })
    },
    setData () {
      // const getData = response => response.data
      // const getObjectByType = type => fp.filter(obj => type === obj.type)
      // const getTotalCountByType = type => fp.flow(getObjectByType(type), fp.first, fp.getOr('0', 'totalcount'))
      // const getListByType = type => fp.flow(getObjectByType(type), fp.first, fp.getOr([], 'list'))
      //
      // fetchOnContent(this.sectionInfo)
      //   .then(getData)
      //   .then((data) => {
      //     this.totalCount = getTotalCountByType(SEARCH_INFO)(data)
      //     this.faqTotalCount = Number(getTotalCountByType(FAQ)(data))
      //     this.noticeTotalCount = Number(getTotalCountByType(NOTICE)(data))
      //     this.faqList = getListByType(FAQ)(data)
      //     this.noticeList = getListByType(NOTICE)(data)
      //     return data
      //   })
      getSearch({
        keyword: this.keyword,
        orderby: this.orderby,
        limit: 5,
        offset: this.faqOffset,
        type: 'faq'
      }).then((faqRes) => {
        this.faqList = _.get(faqRes, ['data', '1', 'list'], [])
        this.faqTotalCount = parseInt(_.get(faqRes, ['data', '0', 'totalcount'], '0'))
        this.totalCount = this.totalCount + this.faqTotalCount
      })
      getSearch({
        keyword: this.keyword,
        orderby: this.orderby,
        limit: 5,
        offset: this.noticeOffset,
        type: 'notice'
      }).then((noticeRes) => {
        this.noticeList = _.get(noticeRes, ['data', '1', 'list'], [])
        this.noticeTotalCount = parseInt(_.get(noticeRes, ['data', '0', 'totalcount'], '0'))
        this.totalCount = this.totalCount + this.noticeTotalCount
      })
    },
    goAllView (type) {
      const queryParam = {
        name: type,
        query: {
          searchWord: this.keyword
        }
      }
      this.$router.push(queryParam)
    }
  },
  computed: {
    hasSupport () {
      return this.totalCount > 0
    },
    isSearchView () {
      return this.$route.name === 'search'
    }
  },
  created () {
    this.keyword = _.get(this.$route, ['query', 'searchWord'], '')
    this.setData()
  }
}
</script>
